import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UserSharedModule } from '../user-shared';
import { ParticipantRoutingModule } from './participant-routing.module';
import { ParticipantListComponent } from './participant-list/participant-list.component';

@NgModule({
  imports: [
    CommonModule,
    UserSharedModule,
    ParticipantRoutingModule
  ],
  declarations: [
    ParticipantListComponent
  ]
})
export class ParticipantModule { }



// WEBPACK FOOTER //
// /dist/src/app/user/participant/participant.module.ts